import React from 'react';

import { Box, useBreakpointValue } from '@stockx/ui';
import { NavBarInner } from '@app/shell/SiteHeader/shared/components/Header.styles';
import ContentMobile from '@app/shell/SiteHeader/Header/components/Content/components/ContentMobile';
import ContentTabletAndDesktop from '@app/shell/SiteHeader/Header/components/Content/components/ContentTabletAndDesktop';

const Human = () => {
  const { isMobile } = useBreakpointValue();

  return (
    <Box>
      <NavBarInner data-component="MobileNavBarInner">
        {isMobile ? (
          <ContentMobile data-component="MobileHeaderWrapper" />
        ) : null}
        {!isMobile ? <ContentTabletAndDesktop /> : null}
      </NavBarInner>
    </Box>
  );
};

export default Human;
